const parkingSvg = (width, height) => {
  return `<?xml version="1.0" encoding="utf-8"?>
  <svg width="${width}px" height="${height}px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
 
  <path d="M15 10.5C15 11.0967 14.7629 11.669 14.341 12.091C13.919 12.5129 13.3467 12.75 12.75 12.75H10.5V8.25H12.75C13.3467 8.25 13.919 8.48705 14.341 8.90901C14.7629 9.33097 15 9.90326 15 10.5V10.5Z" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10.5 17.25V12.75" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;
};

const gpsJammingSvg = (width, height) => {
  return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="_x32_" width="${width}px" height="${height}px" viewBox="0 0 512 512" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#000000;}
]]>
</style>
<g>
	<path class="st0" d="M465.703,333.352c-9.547-4.078-36.766-13.594-69.453-8.172c-18.984,3.188-126.641,21.813-133.438,21.813   c-6.813,0-6.813,0-6.813,0s0,0-6.813,0S134.734,328.368,115.75,325.18c-32.688-5.422-59.906,4.094-69.453,8.172   C6.234,350.54,19.672,390.665,28.594,405.54c12.25,20.422,58.906,74.079,104.859,80.329   c59.906,8.172,111.656-38.109,122.547-38.109s62.625,46.281,122.547,38.109c45.953-6.25,92.609-59.906,104.859-80.329   C492.328,390.665,505.781,350.54,465.703,333.352z M131.531,423.243c-19.359-19.36-16.125-38.735,6.469-40.344   c22.594-1.625,60.703,8.094,61.344,20.984C200.938,436.165,150.906,442.618,131.531,423.243z M380.469,423.243   c-19.375,19.375-69.406,12.922-67.813-19.36c0.641-12.891,38.75-22.609,61.344-20.984   C396.594,384.508,399.844,403.883,380.469,423.243z"/>
	<path class="st0" d="M486.578,203.086C462.969,59.665,326.766,25.165,256,25.165c-70.75,0-206.984,34.5-230.578,177.922   C9.078,206.727,0,224.883,0,233.961s0,59.906,0,59.906h512c0,0,0-50.828,0-59.906S502.922,206.727,486.578,203.086z"/>
</g>
</svg>`;
};

const fulingSvg = (width, height) => {
  return `<svg width="${width}px" height="${height}px" viewBox="0 0 15 15" version="1.1" id="fuel" xmlns="http://www.w3.org/2000/svg">
    <path d="M13,6L13,6v5.5c0,0.2761-0.2239,0.5-0.5,0.5S12,11.7761,12,11.5v-2C12,8.6716,11.3284,8,10.5,8H9V2c0-0.5523-0.4477-1-1-1H2&#xA;&#x9;C1.4477,1,1,1.4477,1,2v11c0,0.5523,0.4477,1,1,1h6c0.5523,0,1-0.4477,1-1V9h1.5C10.7761,9,11,9.2239,11,9.5v2&#xA;&#x9;c0,0.8284,0.6716,1.5,1.5,1.5s1.5-0.6716,1.5-1.5V5c0-0.5523-0.4477-1-1-1l0,0V2.49C12.9946,2.2178,12.7723,1.9999,12.5,2&#xA;&#x9;c-0.2816,0.0047-0.5062,0.2367-0.5015,0.5184C11.9987,2.5289,11.9992,2.5395,12,2.55V5C12,5.5523,12.4477,6,13,6s1-0.4477,1-1&#xA;&#x9;s-0.4477-1-1-1 M8,6.5C8,6.7761,7.7761,7,7.5,7h-5C2.2239,7,2,6.7761,2,6.5v-3C2,3.2239,2.2239,3,2.5,3h5C7.7761,3,8,3.2239,8,3.5&#xA;&#x9;V6.5z"/>
  </svg>`;
};

const drainSvg = (width, height) => {
  return `<?xml version="1.0" encoding="iso-8859-1"?>
   <svg fill="#000000" width="${width}px" height="${height}px" version="1.1" id="Layer_1"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 511.999 511.999" xml:space="preserve">
  <g>
      <g>
          <path d="M424.688,77.983h-9.021V22.622C415.667,10.128,405.539,0,393.045,0H258.253c-8.789,0-16.782,5.091-20.5,13.056
              l-30.3,64.928h-9.94c-4.39,0-8.6,1.745-11.704,4.849l-5.652,5.652l-23.805-23.805c-6.463-6.463-16.944-6.464-23.409,0
              l-57.336,57.336c-6.464,6.464-6.464,16.945,0,23.409L99.41,169.23l-5.162,5.162c-3.104,3.104-4.849,7.314-4.849,11.704v309.351
              c0,9.141,7.411,16.553,16.553,16.553h318.737c9.142,0,16.553-7.411,16.553-16.553V94.536
              C441.241,85.394,433.829,77.983,424.688,77.983z M361.102,367.366c6.464,6.464,6.464,16.945,0,23.409
              c-6.462,6.463-16.943,6.466-23.409,0l-72.373-72.373l-72.373,72.373c-6.463,6.464-16.944,6.466-23.409,0
              c-6.464-6.464-6.464-16.944,0-23.409l72.373-72.373l-72.373-72.373c-6.464-6.464-6.464-16.944,0-23.409
              c6.463-6.464,16.944-6.464,23.409,0l72.373,72.373l72.373-72.373c6.463-6.464,16.944-6.464,23.409,0
              c6.464,6.464,6.464,16.944,0,23.409l-72.373,72.373L361.102,367.366z M370.424,69.125h-0.001H261.515l11.146-23.881h97.764V69.125
              z"/>
      </g>
  </g>
  </svg>`;
};

const spidingPointsSvg = (width, height) => {
  return `<?xml version="1.0" encoding="iso-8859-1"?>
   <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="${width}px" height="${height}px" viewBox="0 0 29.683 29.682" style="enable-background:new 0 0 29.683 29.682;"
	 xml:space="preserve">
<g>
	<g>
		<path d="M27.709,23.226c1.279-2.223,1.974-4.743,1.974-7.376c0-5.449-2.96-10.208-7.349-12.789
			c-0.026-0.02-0.044-0.048-0.073-0.064c-0.022-0.014-0.05-0.013-0.073-0.024C20.02,1.731,17.515,1.01,14.842,1.01
			S9.665,1.731,7.498,2.971C7.473,2.984,7.446,2.984,7.422,2.998c-0.03,0.017-0.048,0.047-0.075,0.066
			C5.164,4.347,3.342,6.168,2.057,8.35C2.037,8.379,2.008,8.396,1.99,8.427C1.976,8.452,1.976,8.48,1.965,8.504
			c-1.24,2.165-1.96,4.663-1.962,7.331C0.003,15.839,0,15.843,0,15.849c0,0.005,0.002,0.009,0.003,0.015
			c0.002,2.625,0.693,5.138,1.966,7.354c0.009,0.018,0.009,0.037,0.019,0.055c0.019,0.03,0.043,0.053,0.063,0.082
			c0.633,1.076,1.394,2.086,2.299,2.992c0.215,0.215,0.496,0.322,0.777,0.322c0.281,0,0.563-0.107,0.777-0.322
			c0.43-0.43,0.43-1.125,0-1.555c-0.527-0.527-0.993-1.1-1.412-1.695l1.838-1.061c0.525-0.303,0.707-0.975,0.403-1.5
			c-0.302-0.525-0.975-0.707-1.501-0.403l-1.839,1.062c-0.62-1.328-1.012-2.756-1.139-4.242l2.123,0.002c0.001,0,0.001,0,0.001,0
			c0.606,0,1.1-0.492,1.1-1.1c0-0.606-0.492-1.101-1.099-1.101l-2.123-0.001c0.13-1.505,0.529-2.931,1.142-4.239l1.831,1.059
			c0.174,0.101,0.362,0.148,0.55,0.148c0.38,0,0.749-0.196,0.952-0.549c0.305-0.526,0.124-1.198-0.4-1.502L4.497,8.608
			C5.344,7.402,6.394,6.351,7.6,5.504l1.059,1.835c0.204,0.352,0.573,0.549,0.953,0.549c0.186,0,0.375-0.047,0.549-0.146
			c0.524-0.303,0.706-0.977,0.402-1.502L9.505,4.406c1.309-0.612,2.734-1.012,4.238-1.142v2.123c0,0.607,0.492,1.1,1.1,1.1
			s1.1-0.492,1.1-1.1V3.264c1.504,0.13,2.928,0.529,4.236,1.142l-1.06,1.835c-0.305,0.526-0.125,1.198,0.402,1.502
			c0.172,0.1,0.36,0.147,0.549,0.147c0.379,0,0.748-0.197,0.953-0.55l1.061-1.837c2.979,2.09,5.014,5.426,5.345,9.247h-2.125
			c-0.606,0-1.101,0.492-1.101,1.1c0,0.608,0.492,1.1,1.101,1.1h2.128c-0.127,1.485-0.52,2.914-1.14,4.242l-1.841-1.062
			c-0.524-0.303-1.197-0.124-1.502,0.402c-0.303,0.525-0.123,1.197,0.402,1.502l1.842,1.062c-0.414,0.589-0.871,1.152-1.39,1.672
			c-0.428,0.431-0.426,1.126,0.005,1.556c0.43,0.429,1.127,0.426,1.555-0.006c0.898-0.901,1.651-1.908,2.281-2.98
			c0.016-0.021,0.036-0.04,0.051-0.064C27.703,23.256,27.701,23.241,27.709,23.226z"/>
		<path d="M16.124,14.07c-0.362-0.261-0.804-0.419-1.282-0.419c-1.212,0-2.198,0.986-2.198,2.198s0.986,2.198,2.198,2.198
			s2.199-0.984,2.199-2.197c0-0.074-0.016-0.146-0.021-0.217l7.344-5.28L16.124,14.07z M14.438,14.833l-0.049,0.021
			C14.405,14.847,14.42,14.838,14.438,14.833z M13.742,15.85c0-0.404,0.23-0.744,0.558-0.936l1.083,1.871
			c-0.162,0.095-0.34,0.164-0.541,0.164C14.236,16.95,13.742,16.457,13.742,15.85z"/>
		<path d="M20.338,24.274H9.345c-0.604,0-1.1,0.496-1.1,1.101v2.198c0,0.604,0.495,1.1,1.1,1.1h10.993c0.604,0,1.1-0.495,1.1-1.1
			v-2.198C21.438,24.77,20.941,24.274,20.338,24.274z"/>
	</g>
</g>
</svg>`;
};

const markerEventIcon = {
  getMarker: (status = 0) => {
    let type = null;
    let svg = null;

    switch (status) {
      case 0:
        type = "parking";
        svg = `<div style="padding-left: 1px; padding-top: 0px;">${parkingSvg(18, 18)}</div>`;
        break;
      case 3:
        type = "fueling";
        svg = `<div style="padding-left: 4px; padding-top: 2px;">${fulingSvg(15, 15)}</div>`;
        break;
      case 4:
        type = "drain";
        svg = `<div style="padding-left: 3px; padding-top: 3px;">${drainSvg(14, 14)}</div>`;
        break;
      case 5:
        type = "GpsJamming";
        svg = `<div style="padding-left: 2px; padding-top: 2px;">${gpsJammingSvg(15, 15)}</div>`;
        break;

      case 6:
        type = "speedingPoints";
        svg = `<div style="padding-left: 2px; padding-top: 2px;">${spidingPointsSvg(16, 16)}</div>`;
        break;

      default:
        break;
    }

    return `<div class="iconContainer">
     <div class="typeIcon-${type}">${svg}</div>
    </div>`;
  },
};


export default markerEventIcon;
